import React, { useEffect, useState } from 'react';
import { useRelayEnvironment } from 'react-relay';

import { getObjectFromRelayStoreById } from '../../functions';
import { ListItemType } from '../../types';
import LoaderListItem from './LoaderListItem';

export interface IListItemOne {
    itemId?: string;
}

const ListItemOne: React.FC<IListItemOne> = ({ itemId }) => {
    const environment = useRelayEnvironment();

    const [currentItem, setCurrentItem] = useState<ListItemType>();

    const setterCurrentItem = (id?: string) => {
        if (id) {
            const listItem = getObjectFromRelayStoreById<ListItemType>(environment, id);
            if (listItem) {
                setCurrentItem(listItem);
            }
        }
    };

    useEffect(() => {
        setterCurrentItem(itemId);
    }, [itemId]);

    useEffect(() => {
        if (currentItem?.link_id) {
            setterCurrentItem(currentItem?.link_id);
        }
    }, [currentItem]);

    const onUpdateData = (rows: any[]) => {
        const [item] = rows;
        setCurrentItem(item);
    };

    const filterFlexible = itemId !== 'null' ? `[{"or":[{"id":"${itemId}"}]}]` : undefined;

    return (
        <div>
            {!currentItem && filterFlexible && (
                <LoaderListItem onUpdateData={onUpdateData} varRequest={{ filter_flexible: filterFlexible }} />
            )}

            {currentItem && Object.keys(currentItem).length && currentItem.name ? currentItem.name : 'No group'}
        </div>
    );
};

export default ListItemOne;
